import createLightbox from "widok-lightbox";

function getHighestResolutionSrc(srcset) {
  if (!srcset) return null;

  const sources = srcset.split(',').map(entry => {
    const [url, resolution] = entry.trim().split(/\s+/);
    const resValue = parseFloat(resolution) || 1;
    return { url, resolution: resValue };
  });

  sources.sort((a, b) => b.resolution - a.resolution);
  return sources[0]?.url || null;
}

const lightbox = createLightbox({
  wrap: '#lightbox',
  close: '#lightbox .lightbox-close',
  prev: '#lightbox .lightbox-prev',
  next: '#lightbox .lightbox-next',
  source: '.type_masonry img',
  transition: 300,
  onChange: source => {
    console.log(lightbox);
  },
});

lightbox.sources.forEach(source => {
  source.url = getHighestResolutionSrc(source.element.attr('srcset'));
});
